<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <h1>Теги</h1>
      <v-row align="center">
        <v-col class="text-right" >
          <v-dialog v-model="dialog" max-width="445">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                      v-bind="attrs"
                      v-on="on"
                      @click="setImage"
              >
                Создать тег
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ tag.id ? 'Редактировать тег' : 'Создать тег'}}</span>
              </v-card-title>
              <v-card-text>
                <v-tabs v-model="tab">
                  <v-tab>RU</v-tab>
                  <v-tab>UA</v-tab>
                </v-tabs>
                <v-form ref="tabForm" v-model="valid">
                <v-tabs-items v-model="tab" class="">
                  <v-tab-item :eager="true">
                    <v-text-field
                            label="Название"
                            outlined
                            v-model="tag.name"
                            :rules="[rules.required]"
                            required>
                    </v-text-field>
                    <v-img :src="previewImage(image)" width="100" height="100" class="mb-8" contain>
                      <template v-slot:placeholder>
                        <div class="image-placeholder"></div>
                      </template>
                    </v-img>
                    <v-file-input label="Иконка"
                                  prepend-icon=""
                                  outlined
                                  accept="image/png"
                                  placeholder="png"
                                  class="cursor-pointer"
                                  append-icon="mdi-attachment"
                                  v-model="image">
                    </v-file-input>
                  </v-tab-item>
                  <v-tab-item :eager="true">
                    <v-text-field
                            label="Название"
                            outlined
                            v-model="tag.name_ua"
                            :rules="[rules.required]"
                            required
                    ></v-text-field>
                    <v-img :src="previewImageUa(imageUa)" width="100" height="100" class="mb-8" contain>
                      <template v-slot:placeholder>
                        <div class="image-placeholder"></div>
                      </template>
                    </v-img>
                    <v-file-input label="Иконка"
                                  prepend-icon=""
                                  outlined
                                  accept="image/png"
                                  placeholder="png"
                                  class="cursor-pointer"
                                  append-icon="mdi-attachment"
                                  v-model="imageUa">
                    </v-file-input>
                  </v-tab-item>
                </v-tabs-items>
                </v-form>
              </v-card-text>
              <v-card-actions class="text-left">

                <v-btn v-if="tag.id" @click="updateTag()" :loading="loadingModal">Сохранить</v-btn>
                <v-btn v-else @click="createTag()" :loading="loadingModal">Добавить</v-btn>
                <v-btn @click="dialog = false" outlined>Отменить</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет тегов"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="tags"
              :options.sync="options"
              :footer-props="footerProps"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :loading="loading"
              loading-text="Загрузка тегов... Подождите пожалуйста"
      >
        <template v-slot:item.actions="{ item }">
          <div class="text-right">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="tag = Object.assign({}, item); setImage(); dialog = true">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-overlay
            :z-index="4"
            :value="overlay"
    >
    </v-overlay>
    <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            :color="snackbarColor"
            right
            top
    >
      {{ snackbarText }}
    </v-snackbar>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import ProductService from './../../api/ProductService'
    import CategoryService from './../../api/CategoryService'
    import TagService from './../../api/TagService'

    export default {
        name: 'TagIndex',
        components: {},
        data: () => ({
            snackbar: false,
            timeout: 2000,
            snackbarText: '',
            snackbarColor: '',
            valid: false,
            submitDialog: false,
            submitItem: null,
            overlay: false,
            loadingModal: false,
            loading: true,
            tab: null,
            dialog: false,
            tags: [],
            options: {},
            image: null,
            imageUa: null,
            tag: {
                id: null,
                name: '',
                name_ua: '',
                image: ''
            },
            rules: {
              required: value => !!value || 'Нужно заполнить',
              requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
            },
            footerProps: {
                itemsPerPageText: 'Тегов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
                itemsPerPageOptions: [-1]
            },
            headers: [
                {
                    text: 'Тег',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Количество',
                    value: 'products_count',
                    sortable: false
                },
                {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
            ],
        }),
        mounted() {
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
        },
        methods: {
          setImage(){
            if(this.tag.image){
              this.image = this.tag.image;
              this.image.name = this.tag.image.file
            } else {
              this.image = null
            }

            if(this.tag.image_ua){
              this.imageUa = this.tag.image_ua;
              this.imageUa.name = this.tag.image_ua.file
            } else {
              this.imageUa = null
            }
          },
          previewImage(tagImage) {
            if(this.image && this.image.url){
              return this.image.url
            }
            if(tagImage){
              return URL.createObjectURL(tagImage)
            }
            return null;

          },
          previewImageUa(tagImage) {
            if(this.imageUa && this.imageUa.url){
              return this.imageUa.url
            }
            if(tagImage){
              return URL.createObjectURL(tagImage)
            }
            return null;

          },
          submitDelete(item = null){
            if(item){
              this.removeTag(item)
            } else {
              // this.massDelete()
            }
          },
            validate(){
              this.$refs.tabForm.validate()
              if(this.tag.name == '' && this.tag.name_ua != ''){
                this.tab = 0;
              }
              if(this.tag.name != '' && this.tag.name_ua == ''){
                this.tab = 1;
              }
            },
            removeTag(item){
              TagService.remove(item.id).then(response => {
                  this.loading = true
                  this.getDataFromApi()
              })
            },
            getData(){
              let formData = new FormData();

              formData.append('name_ua', this.tag.name_ua);
              formData.append('name', this.tag.name);
              if(this.tag.id){
                formData.append('id', this.tag.id);
              }
              if(this.image && !this.image.url) {
                formData.append('image', this.image);
              }
              if(this.imageUa && !this.imageUa.url) {
                formData.append('imageUa', this.imageUa);
              }
              return formData
            },
            createTag(){
              this.validate();
              if(!this.valid){
                return false;
              }
              let data = this.getData();
                this.loadingModal = true;
                TagService.create(data).then(response => {
                    this.getDataFromApi();
                    this.snackbar = true;
                    this.snackbarText = 'Тег создан';
                    this.snackbarColor = 'success';
                }).catch(error => {
                  this.snackbar = true;
                  this.snackbarText = 'Ошибка при создании тега';
                  this.snackbarColor = 'error';
                }).finally(() => {
                    this.dialog = false;
                    this.loadingModal = false;
                })
            },
            updateTag(){
              this.validate();
              if(!this.valid){
                return false;
              }
              let data = this.getData();
                this.loadingModal = true;
                TagService.update(data).then(response => {
                    this.getDataFromApi();
                    this.snackbar = true;
                  this.snackbarText = 'Тег обновлен';
                  this.snackbarColor = 'success';
                }).catch(error => {
                  this.snackbar = true;
                  this.snackbarText = 'Ошибка при обновлении тега';
                  this.snackbarColor = 'error';
                }).finally(() => {
                    this.dialog = false;
                    this.loadingModal = false;
                })
            },
            getDataFromApi() {
                this.loading = true
              this.selected = [];
                TagService.list({})
                    .then(response => {
                        this.tags = response.data
                        this.loading = false
                    })
            },
        }
    }
</script>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
